import branch from './branch.json';
import content from './content.json';
import contentFill from './contentFill.json';
import databaseBackup from './databaseBackup.json';
import databaseServer from './databaseServer.json';
import defaultTranslations from './default.json';
import errorLog from './errorLog.json';
import eventLog from './eventLog.json';
import gitRepository from './gitRepository.json';
import job from './job.json';
import mailLog from './mailLog.json';
import mailTemplate from './mailTemplate.json';
import mailTemplateFill from './mailTemplateFill.json';
import permission from './permission.json';
import resetPassword from './resetPassword.json';
import role from './role.json';
import tenant from './tenant.json';
import user from './user.json';
import userTenantRole from './userTenantRole.json';

export default {
  branch,
  content,
  contentFill,
  databaseBackup,
  databaseServer,
  default: defaultTranslations,
  errorLog,
  eventLog,
  gitRepository,
  job,
  mailLog,
  mailTemplate,
  mailTemplateFill,
  permission,
  resetPassword,
  role,
  tenant,
  user,
  userTenantRole,
};
